var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallDetailsSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2V1H11V2H6ZM6 4V3H11V4H6ZM6 6V5H11V6H6ZM9.475 11C8.43333 11 7.40417 10.7728 6.3875 10.3185C5.37083 9.86417 4.44583 9.2205 3.6125 8.3875C2.77917 7.55417 2.1355 6.62917 1.6815 5.6125C1.2275 4.59583 1.00033 3.56667 1 2.525C1 2.375 1.05 2.25 1.15 2.15C1.25 2.05 1.375 2 1.525 2H3.55C3.66667 2 3.77083 2.03967 3.8625 2.119C3.95417 2.19833 4.00833 2.292 4.025 2.4L4.35 4.15C4.36667 4.28333 4.3625 4.39583 4.3375 4.4875C4.3125 4.57917 4.26667 4.65833 4.2 4.725L2.9875 5.95C3.15417 6.25833 3.352 6.55633 3.581 6.844C3.81 7.13167 4.06217 7.40867 4.3375 7.675C4.59583 7.93333 4.86667 8.173 5.15 8.394C5.43333 8.615 5.73333 8.817 6.05 9L7.225 7.825C7.3 7.75 7.398 7.69367 7.519 7.656C7.64 7.61833 7.75867 7.608 7.875 7.625L9.6 7.975C9.71667 8.00833 9.8125 8.06883 9.8875 8.1565C9.9625 8.24417 10 8.342 10 8.45V10.475C10 10.625 9.95 10.75 9.85 10.85C9.75 10.95 9.625 11 9.475 11Z",
    fill: "#575757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallDetailsSvg);
export default __webpack_public_path__ + "static/media/CallDetailsSvg.cc83cd5f96b1b737382ef25f7c88eeb4.svg";
export { ForwardRef as ReactComponent };